module.exports = __webpack_public_path__ + "static/image2-760279e8a14d4868f2064f1c014b366f.jpg";